import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { AuthShell } from "@/features/auth/AuthShell";
import { authService } from "@/services/authService";
import { apiError } from "@/services/api";
import { Button } from "@/components";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setStatus("error"); setMessage("Ingen token angavs."); return; }
    authService.verifyEmail(token)
      .then(() => setStatus("ok"))
      .catch((e) => { setStatus("error"); setMessage(apiError(e)); });
  }, [token]);

  return (
    <AuthShell title="E-postverifiering" subtitle="Aktiverar ditt konto">
      <div className="flex flex-col items-center gap-4 text-center" data-testid="verify-email-page">
        {status === "loading" && <><Loader2 className="h-10 w-10 animate-spin text-primary" /><p>Verifierar…</p></>}
        {status === "ok" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-emerald-500" />
            <p className="text-lg font-semibold" data-testid="verify-success">Din e-postadress är verifierad!</p>
            <Button asChild data-testid="verify-to-dashboard"><Link to="/dashboard">Gå till instrumentpanelen</Link></Button>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-12 w-12 text-destructive" />
            <p className="text-lg font-semibold" data-testid="verify-error">Verifiering misslyckades</p>
            <p className="text-sm text-muted-foreground">{message}</p>
            <Button asChild variant="outline"><Link to="/dashboard">Till instrumentpanelen</Link></Button>
          </>
        )}
      </div>
    </AuthShell>
  );
}
